<span [innerHTML]="textArray[0]"></span>
@if (showHref) {
  <a class="linkClass" href="{{link}}" target="{{target}}">{{textArray[1]}}</a>
}
@if (showOnClick) {
  <a class="linkClass" (click)="linkFn()" href="javascript:undefined"><span [innerHTML]="textArray[1]"></span></a>
}
<span [innerHTML]="textArray[2]"></span>